export default __webpack_public_path__ + "static/media/ai_trading_2.765af02f.png";